<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <input  type="datetime" class="form-control" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}" [date]="date" (dateChange)="onDateChange($event)" bsDatepicker
        datePickerMomentModifier [bsConfig]="datePickerConfig" (change)="onDateEmpty($event)">

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>

</div>
